// TFH Scroll Reveal — sections fade + rise as they enter the viewport.
// Progressive enhancement: if anything fails, content stays fully visible.
(function () {
  'use strict';

  // Bail entirely if the user prefers reduced motion — no hidden states, ever.
  var prefersReduced = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduced) return;

  // Bail if IntersectionObserver isn't supported (very old browsers) —
  // content just shows normally with no animation.
  if (!('IntersectionObserver' in window)) return;

  var docEl = document.documentElement;

  // Sections we never animate: site chrome + overlays.
  var EXCLUDE = [
    'header-group', 'footer-group', 'g_header', 'g_footer',
    'g_announcement', 'announcement', 'g_newsletter-popup',
    'predictive-search', 'cart-drawer', 'modal',
  ];

  function isExcluded(section) {
    var id = (section.id || '').toLowerCase();
    var cls = (section.className || '').toString().toLowerCase();
    for (var i = 0; i < EXCLUDE.length; i++) {
      if (id.indexOf(EXCLUDE[i]) !== -1 || cls.indexOf(EXCLUDE[i]) !== -1) return true;
    }
    return false;
  }

  function init() {
    // Target top-level Shopify section wrappers inside the main content area.
    var main = document.getElementById('MainContent') || document.body;
    var sections = Array.prototype.slice.call(
      main.querySelectorAll('.shopify-section, [class*="shopify-section"]')
    );

    // Only animate top-level sections (not nested ones), and skip chrome.
    var targets = sections.filter(function (s) {
      if (isExcluded(s)) return false;
      // Skip nested sections (a section inside another section)
      if (s.parentElement && s.parentElement.closest('.shopify-section')) return false;
      return true;
    });

    if (!targets.length) return;

    // Mark ready — this is the ONLY moment hidden states become active,
    // guaranteeing no flash-of-hidden-content if the script is slow/blocked.
    docEl.classList.add('tfh-sr-ready');

    targets.forEach(function (el) { el.classList.add('tfh-sr'); });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('tfh-sr--visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      // Reveal a little before fully in view, and only once ~12% is showing.
      rootMargin: '0px 0px -8% 0px',
      threshold: 0.12,
    });

    targets.forEach(function (el) {
      // If a section is already in view on load (above the fold), reveal it
      // immediately without animation so the hero doesn't flash.
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.85) {
        el.classList.add('tfh-sr--visible');
      } else {
        observer.observe(el);
      }
    });

    // Safety net: if anything is still hidden after 4s (e.g. an observer
    // edge case), force-reveal so content is never stuck invisible.
    setTimeout(function () {
      targets.forEach(function (el) { el.classList.add('tfh-sr--visible'); });
    }, 4000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
